import { OPERATION_METHOD, PublishedTableOfContents } from '~/portal/types/content'
import { isPublishedDocumentContent } from '~/portal/utils/shared/content'

export const NESTING_ITEM_MARGIN = 18

export const extractProductPathFromUrl = (pathname: string) => [pathname.split('/')[2], pathname.split('/')[3]].join('/')

export const findPathToActiveItem = (tableOfContents: PublishedTableOfContents[], pathname: string) => {
  const path: string[] = []
  const productPath = extractProductPathFromUrl(pathname)

  const traverse = (items) => {
    for (const item of items) {
      const hasTocId = Boolean(item.tableOfContentsId)
      if (hasTocId) {
        path.push(item.tableOfContentsId)
      }
      if (item.path === productPath) {
        return true
      }
      if (item.children && traverse(item.children)) {
        return true
      }
      if (hasTocId) {
        path.pop()
      }
    }
    return false
  }

  traverse(tableOfContents)

  return path
}

export const flattenTocIds = (tocItems: PublishedTableOfContents[]): string[] => tocItems.reduce((flatIds, item) => {
  if (item.tableOfContentsId) {
    flatIds.push(item.tableOfContentsId)
  }

  if (isPublishedDocumentContent(item) && item.children?.length > 0) {
    flatIds = flatIds.concat(flattenTocIds(item.children))
  }

  return flatIds
}, [] as string[])

export const calculateNestedMargin = (level: number, isMobile?: boolean) => {
  if (level === 0) {
    return 0
  }
  const maxMobileLevel = 5
  if (isMobile && level > maxMobileLevel) {
    return 8 + maxMobileLevel * NESTING_ITEM_MARGIN
  }
  return 8 + level * NESTING_ITEM_MARGIN
}

export const getMethodDisplayText = (method: string): string => {
  switch (method.toLowerCase()) {
    case OPERATION_METHOD.DELETE:
      return 'DEL'
    case OPERATION_METHOD.QUERY:
      return 'QRY'
    case OPERATION_METHOD.OPTIONS:
      return 'OPTS'
    default:
      return method
  }
}